import {Url} from "../constants/environment";

class cookie {
  static setUserCookie(name, value, exp = null) {
    let domain = '';

    if (window.location.hostname === 'localhost') {
      domain = window.location.hostname;
    } else {
      const hostname = window.location.hostname;
      let baseDomain = hostname;

      if (hostname.startsWith('dev-m.')) {
        baseDomain = hostname.replace('dev-m.', '');
      } else if (hostname.startsWith('m-stage.')) {
        baseDomain = hostname.replace('m-stage.', '');
      } else if (hostname.startsWith('m.')) {
        baseDomain = hostname.replace('m.', '');
      } else if (hostname.startsWith('dev.')) {
        baseDomain = hostname.replace('dev.', '');
      } else if (hostname.startsWith('stage.')) {
        baseDomain = hostname.replace('stage.', '');
      }

      domain = '.' + baseDomain;
    }

    const options = { domain };

    if (exp !== null && exp !== undefined) {
      let date = new Date();
      date.setTime(date.getTime() + 1000 * exp);
      options.expires = date.toUTCString();
    }

    cookie.setCookie(name, value, options);
  }

  static setCookie(name, value, options = {}) {
    options = {
      path: '/',
      ...options
    };

    // if (options.expires instanceof Date) {
    //   options.expires = options.expires.toUTCString();
    // }

    let updatedCookie =
      encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += '; ' + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  static getCookie(name) {
    if (typeof window !== 'undefined') {
      let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return value ? value[2] : null;
    }
  }

  static deleteCookie(name) {
    console.log('deleteCookie ==================');
    if (typeof window !== 'undefined') {
      let date = new Date();
      // debugger;
      let domain = '';

      if (window.location.hostname === 'localhost') {
        domain = window.location.hostname;
      } else if (window.location.hostname.startsWith('dev-m.')) {
        domain = '.' + window.location.hostname.replace('dev-m.', '');
      } else {
        let check = window.location.hostname.includes(Url.hostNamedWeb);
        
        domain = check ? '.' + Url.hostNamedWeb : window.location.hostname;
      }

      cookie.setCookie(name, '', {
        domain,
        expires: date.toUTCString()
      });

      // let date = new Date();
      // document.cookie =
      //   name + '= ' + '; expires=' + date.toUTCString() + '; path=/';
    }
  }
}

export default cookie;
